import React from 'react'
import { Field, Formik } from 'formik'
import { Form, Button } from 'lib/ui/components'
import { DatePickerInput } from 'app/livbrite/components/DatePicker'
import { Container } from './styled'

interface Prop {
  onSubmit: any
  multipleRanges: boolean
}

export const DateRange: React.FC<Prop> = ({ onSubmit, multipleRanges }) => {
  const schema = {
    fromDate: '',
    toDate: '',
    fromDate2: '',
    toDate2: ''
  }

  return (
    <Container
      multipleLines={multipleRanges}
    >
      <Formik
        onSubmit={onSubmit}
        initialValues={schema}
        validator={() => ({})}
      >
        {() => {
          return (
            <Form.Wrapper>
              <Field
                name='fromDate'
                label='From Date'
                component={DatePickerInput}
              />
              <Field
                name='toDate'
                label='To Date'
                component={DatePickerInput}
              />
              {multipleRanges && (
                <div className='second-line'>
                  <p>Second date range</p>
                  <Field
                    name='fromDate2'
                    label='From Date'
                    component={DatePickerInput}
                  />
                  <Field
                    name='toDate2'
                    label='To Date'
                    component={DatePickerInput}
                  />
                </div>
              )}
              <Button type='submit'>
                Select date range
              </Button>
            </Form.Wrapper>
          )
        }}
      </Formik>
    </Container>
  )
}
